'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './db-admin-list.routes';

export class DbAdminListComponent {
  constructor(Auth, DBAdminService, dialogs, $stateParams, $uibModal) {
    'ngInject';

    this.DBAdminService = DBAdminService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;
    this.$uibModal = $uibModal;

    this.collection = $stateParams.collection;

    this.dialogs = dialogs;

    this.settings = {
      collections: [
        "users", "",
        "communities", "properties", "contacts", "vendors", "webaccess", "custom-entities", "",
        "calendarevents", "tasks", "projects", "project-items",
        "servicerequests", "workorders", "workorder-codes", "violations", "violation-codes", "templates", "",
        "settings", "storages", "histories", "sessions"],
      colDef: {
        "users": ["_id", "firstName", "lastName", "email"],
        "communities": ["_id", "code", "name"],
        "properties": ["_id", "code", "name"],
        "contacts": ["_id", "firstName", "lastName"],
        "vendors": ["_id", "name", "type"],
        "webaccess": ["_id", "email"],
        "custom-entities": ["_id", "schemaSettings"],
        "calendarevents": ["_id", "title", "type", "start"],
        "tasks": ["_id","subject", "priority", "dueDate", "status"],
        "projects": ["_id","name"],
        "project-items": ["_id","title"],
        "servicerequests": ["_id", "code", "name"],
        "workorders": ["_id", "code", "name"],
        "workorder-codes": ["_id", "code", "name"],
        "violations": ["_id", "code", "name"],
        "violation-codes": ["_id", "code", "name"],
        "templates": ["_id", "name", "fileName"],
        "settings": ["_id", "name", "isPublic", "tags"],
        "storages": ["_id", "filename", "contentType","storageStrategy", "permission","isPublic", "dataUrl"],
        "histories": ["_id","entityId", "entityType", "action", "actionType"],
        "sessions": ["_id", "expires"]
      }
    };

    this.settings.collections.forEach(c => {
      if (!this.settings.colDef[c])
        this.settings.colDef[c] = ["_id"]
    });

    this.DBAdminService.query({collection: this.collection}, data => {
      this.data = data;
    }, err => {
      console.log("Could not retrieve entities.")
    })

  }

  openPreviewModal(entity) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'jsonViewer',
      resolve: {
        config: function() {
          return {
            data: entity
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () { /* ok */ },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduu.ap.dbAdmin.list', [uiRouter])
  .config(routes)
  .component('dbAdminList', {
    template: require('./db-admin-list.html'),
    controller: DbAdminListComponent,
    controllerAs: 'ctrl',

  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/db/list/db-admin-list.component.js